import { render, staticRenderFns } from "./PendingAccount.vue?vue&type=template&id=2741f738&"
import script from "./PendingAccount.vue?vue&type=script&lang=js&"
export * from "./PendingAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports